import { render, staticRenderFns } from "./homeowner-chat.vue?vue&type=template&id=385703be&scoped=true"
import script from "./homeowner-chat.vue?vue&type=script&lang=js"
export * from "./homeowner-chat.vue?vue&type=script&lang=js"
import style0 from "./homeowner-chat.vue?vue&type=style&index=0&id=385703be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385703be",
  null
  
)

export default component.exports